import { createBuilderModule } from '../../register-builder/builder-module';
import { ABVariant } from './ABVariant';
import { withChildren } from '@builder.io/react';

export default createBuilderModule(withChildren(ABVariant), {
  name: 'ABVariant',
  image: 'https://cdn.zappy.app/f8cf0c0326588be441590818d2dc6dd3.png',
  inputs: [
    {
      name: 'variantName',
      type: 'string',
      required: true,
      helperText: 'The name of the corresponding variant in Split.io',
    },
    {
      name: 'preview',
      type: 'boolean',
      helperText:
        'Would you like to see it when in preview/edit mode? Only if this is true, will the child block show while either editing or viewing current draft',
    },
  ],
});
